import { Collection, IViolation } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SingleStreamOutputTransformation } from './single-output-stream.transformation';
import { DataFlowColumn } from '../dataset/dataflowcolumn';

import { NamedArray } from '../base/namedarray';
import { sanitizeAndFormatString } from '../../shared/utils/string.util';

@Metamodel.model({
    name: 'baseschemageneratortransformation', // As this is abstract this will never be used
    abstract: true
})
export abstract class BaseSchemaGeneratorTransformation extends SingleStreamOutputTransformation {
    public get columns(): DataFlowColumn[] {
        return this.schema;
    }

    @Metamodel.attribute({
        type: DataFlowColumn.MODEL,
        collection: Collection.Array,
        constraint: {
            uniqueCaseSensitive: true,
            validator: BaseSchemaGeneratorTransformation.ValidateColumnNames
        },
        display: stringResources.Schema
    })
    public schema = NamedArray.create<DataFlowColumn>(this);

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static ValidateColumnNames(transformation: BaseSchemaGeneratorTransformation): IViolation[] | undefined {
        const violations: IViolation[] = [];

        if (!transformation.schema || !transformation.schema.length) {
            if (transformation.bypassSchemaValidation()) {
                return violations;
            }

            violations.push({
                context: transformation,
                message: () => sanitizeAndFormatString(stringResources.DataFlowEmptySchemaError, transformation.name)
            });
        } else {
            transformation.schema.forEach((column) => {
                if (!column.name) {
                    violations.push({
                        context: column,
                        message: () => sanitizeAndFormatString(stringResources.DataFlowSchemaEmptyColumnNameError, transformation.name)
                    });
                }

                if (!column.columnType) {
                    violations.push({
                        context: column,
                        message: () => sanitizeAndFormatString(stringResources.DataFlowSchemaEmptyColumnTypeError, transformation.name)
                    });
                }
            });
        }
        return violations;
    }

    public bypassSchemaValidation = () => (false);
}
